import { createSlice } from "@reduxjs/toolkit";

export const initialState = {
  user: "",
  error: "",
  loading: false,
  isUserLogout: false,
  errorFlag: false,
  requireCaptcha: false,
};

const loginSlice = createSlice({
  name: "login",
  initialState,
  reducers: {
    apiError(state, action) {
      state.error = action.payload;
      state.loading = true;
      state.isUserLogout = false;
      state.errorFlag = true;
    },
    loginSuccess(state, action) {
      state.user = action.payload;
      state.errorFlag = false;
      state.loading = false;
    },
    logoutUserSuccess(state, action) {
      state.isUserLogout = true;
    },
    reset_login_flag(state, action) {
      state.error = null;
      state.loading = false;
      state.errorFlag = false;
    },
    setCaptchaRequired(state, action) {
      state.requireCaptcha = action.payload;
    },
  },
});

export const { apiError, loginSuccess, logoutUserSuccess, reset_login_flag, setCaptchaRequired } =
  loginSlice.actions;

export default loginSlice.reducer;
